const decodeRuntimeConfig = () => {
    const configBytes = window.__APP_CONFIG_BYTES__;

    if (!Array.isArray(configBytes)) {
        return {};
    }

    try {
        const json = new TextDecoder('utf-8').decode(new Uint8Array(configBytes));
        return JSON.parse(json);
    } catch (error) {
        console.error('Failed to decode runtime config', error);
        return {};
    }
};

const runtimeConfig = decodeRuntimeConfig();

const toBoolean = value => ['1', 'true', 'yes', 'on'].includes(String(value).toLowerCase());

const appConfig = Object.freeze({
    cpsApiBaseUrl: runtimeConfig.CPS_API_BASE_URL || process.env.VUE_APP_CPS_API_BASE_URL || '',
    signKey: runtimeConfig.CPS_SIGN_KEY || process.env.VUE_APP_SIGN_KEY || '',
    ossRegion: runtimeConfig.OSS_REGION || process.env.VUE_APP_OSS_REGION || 'oss-cn-shanghai',
    ossBucket: runtimeConfig.OSS_BUCKET || process.env.VUE_APP_OSS_BUCKET || '',
    ossUrl: runtimeConfig.OSS_URL || process.env.VUE_APP_OSS_URL || '',
    mediaPcUrl: runtimeConfig.MEDIA_PC_URL || process.env.VUE_APP_MEDIA_PC_URL || '',
    pcAdapter: toBoolean(
        runtimeConfig.CPS_AUTO_ADAPTER
        ?? process.env.VUE_APP_CPS_AUTO_ADAPTER
        ?? process.env.VUE_APP_PC_ADAPTER
    ),
    cpsPcUrl: runtimeConfig.CPS_PC_URL || process.env.VUE_APP_CPS_PC_URL || '',
});

export default appConfig;
